import { CampaignState } from 'constants/campaignStates';
import { EmbeddedMessageMedium, MessageMedium, WhatsAppMedium } from 'constants/messageMediums';
import { CampaignTypeFilter } from 'modules/domains/campaign';
import { useRestPostQuery, UseRestPostQueryQueryOptions } from 'utils/hooks/api';

type QueryCampaignsForMetricsParams = {
  endTime: string;
  startTime: string;
  campaignFiltersOpt: {
    mediums: (MessageMedium | WhatsAppMedium | EmbeddedMessageMedium)[];
    states: CampaignState[];
    types: CampaignTypeFilter[];
  };
};

export type CampaignForMetric = {
  campaignId: number;
  campaignName: string;
  campaignType: CampaignTypeFilter;
  campaignState: string;
  templateId: number;
  mobileAppIds: number[];
  launchDate: string;
  medium: MessageMedium;
  dataScienceOptimizations: string[];
};

export type QueryCampaignsForMetricsResponse = {
  campaigns: CampaignForMetric[];
};

export type UseQueryCampaignsForMetricsState = ReturnType<typeof useQueryCampaignsForMetrics>;

export const CAMPAIGNS_FOR_METRICS_API_URL = '/analytics/getCampaignsForMetrics';

export const useQueryCampaignsForMetrics = (
  params: QueryCampaignsForMetricsParams,
  options?: UseRestPostQueryQueryOptions<QueryCampaignsForMetricsResponse>,
) => {
  const { data, isLoading, isError, error } = useRestPostQuery(
    CAMPAIGNS_FOR_METRICS_API_URL,
    params,
    options,
  );

  return {
    campaigns: data?.campaigns ?? ([] as CampaignForMetric[]),
    isLoading,
    hasError: isError,
    errorMessage: error,
  };
};
